import React from 'react';
import type { TextT } from '@mentimeter/ragnar-ui/text';
import { Text } from '@mentimeter/ragnar-ui/text';

export const Badge = (props: TextT) => (
  <Text
    color="primary"
    fontSize="100"
    textTransform="uppercase"
    {...props}
    extend={() => ({
      letterSpacing: '4px',
    })}
  />
);
